<template>
  <section>
    <div>
      <div class="box box-primary"> 
        <section class="content">
          <div class="row">
            <div class="col-md-4">
            <span>Select Branch</span>
            <v-select :options="branches" label="name" name="branch" placeholder="Select" v-model="branch"></v-select>
            </div>
            <div class="col-md-4">
                <span>Select Date</span>
                <input v-model="form.date" type="date" name="date" class="form-control"  />
            </div>
            <div class="col-md-2">
              <br>
              <button type="button" @click="changeFilter()"  class="form-control btn-info"><i class="fa fa-search"></i> GET RECORDS</button>
          </div>
          </div>
          <div class="row">
            <div class="col-md-12 bg-green">
            <center><strong>CASH BOOK</strong></center>
            </div>
            <div class="col-md-6">
                <table class="table">
                    <thead>
                      <th colspan="4" class="text-center"><strong>Cash Records</strong></th>
                    </thead>
                    <tbody>
                      <tr>
                        <th colspan="2" class="text-center">Debit</th>
                        <th colspan="2" Class="text-center">Credit</th>
                      </tr>
                      <tr style="background-color: #d6dddd;">
                        <td><strong>Particulars</strong></td>
                        <td><strong>Dr</strong></td>
                        <td><strong>Particulars</strong></td>
                        <td><strong>Cr</strong></td>
                      </tr>
                      <tr>
                        <td><span v-if="cashbookcashRecord.opening_balance >= 0">Opening Balance</span></td>
                        <td><span v-if="cashbookcashRecord.opening_balance >= 0">{{ parseFloat(cashbookcashRecord.opening_balance + 0).toFixed(2)}}</span></td>
                        <td><span v-if="cashbookcashRecord.opening_balance < 0">Opening Balance</span></td>
                        <td><span v-if="cashbookcashRecord.opening_balance < 0">{{ parseFloat(cashbookcashRecord.opening_balance + 0).toFixed(2)}}</span></td>
                      </tr>
                      <tr v-for="(voucher, index) in cashbookcashRecord.vouchers" :key="index">
                        
                        <td><span v-if="voucher.type === 'cr'">{{ voucher.ledger.name }}</span></td>
                        <td><span v-if="voucher.type === 'cr'">{{ parseFloat(voucher.total_amt + 0).toFixed(2) }}</span></td>
                        <td><span v-if="voucher.type === 'dr'">{{ voucher.ledger.name }}</span></td>
                        <td><span v-if="voucher.type === 'dr'">{{ parseFloat(voucher.total_amt + 0).toFixed(2) }}</span></td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>{{ parseFloat(cashbookcashRecord.dr_total + 0).toFixed(2)}}</td>
                        <td>Total</td>
                        <td>{{ parseFloat(cashbookcashRecord.cr_total + 0).toFixed(2)}}</td>
                      </tr>
                      <tr>
                        <td class="text-center" colspan="4"><strong>Closing Balance {{ parseFloat(cashbookcashRecord.closing_balance + 0).toFixed(2) }} ({{ cashbookcashRecord.closing_balance_type }})</strong></td>
                      </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-md-6">
                <table class="table">
                    <thead>
                      <th colspan="4" class="text-center"><strong>Bank Records</strong></th>
                    </thead>
                    <tbody>
                      <tr>
                        <th colspan="2" class="text-center">Debit</th>
                        <th colspan="2" Class="text-center">Credit</th>
                      </tr>
                      <tr style="background-color: #d6dddd;">
                        <td><strong>Particulars</strong></td>
                        <td><strong>Dr</strong></td>
                        <td><strong>Particulars</strong></td>
                        <td><strong>Cr</strong></td>
                      </tr>
                      <tr>
                        <td><span v-if="cashbookbankRecord.opening_balance >= 0">Opening Balance</span></td>
                        <td><span v-if="cashbookbankRecord.opening_balance >= 0">{{ parseFloat(cashbookbankRecord.opening_balance + 0).toFixed(2)}}</span></td>
                        <td><span v-if="cashbookbankRecord.opening_balance < 0">Opening Balance</span></td>
                        <td><span v-if="cashbookbankRecord.opening_balance < 0">{{ parseFloat(cashbookbankRecord.opening_balance + 0).toFixed(2)}}</span></td>
                      </tr>
                      <tr v-for="(voucher, index) in cashbookbankRecord.vouchers" :key="index">
                        
                        <td><span v-if="voucher.type === 'cr'">{{ voucher.ledger.name }}</span></td>
                        <td><span v-if="voucher.type === 'cr'">{{ parseFloat(voucher.total_amt + 0).toFixed(2)}}</span></td>
                        <td><span v-if="voucher.type === 'dr'">{{ voucher.ledger.name }}</span></td>
                        <td><span v-if="voucher.type === 'dr'">{{ parseFloat(voucher.total_amt + 0).toFixed(2)}}</span></td>
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>{{ parseFloat(cashbookbankRecord.dr_total + 0).toFixed(2)}}</td>
                        <td>Total</td>
                        <td>{{ parseFloat(cashbookbankRecord.cr_total + 0).toFixed(2)}}</td>
                      </tr>
                      <tr>
                        <td class="text-center" colspan="4"><strong>Closing Balance {{ parseFloat(cashbookbankRecord.closing_balance + 0).toFixed(2)}} ({{ cashbookbankRecord.closing_balance_type }})</strong></td>
                      </tr>
                    </tbody>
                </table>
            </div>
            <hr>
          </div>
        </section>
      </div>
    </div>
  </section>
</template>
<script>
import GetBranch from '../../mixins/BranchRecords'
export default({
  Name: 'Cashbook',
  mixins: [GetBranch],
  data () {
    return {
      branches: [],
      branch: {},
      cashbookcashRecord: {},
      cashbookbankRecord: {},
      form: new Form({
        branch_id: '',
        date: new Date().toISOString().slice(0, 10)
      })
    }
  },
  methods: {
    changeFilter () {
      if (this.branch) {
        this.form.branch_id = this.branch.id
      }
      this.$axios
        .post('rokad/cash', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((data) => {
          this.cashbookcashRecord = data.data.data
        }).catch(function (error) { console.log(error) })
      this.$axios
        .post('rokad/bank', this.form, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((data) => {
          this.cashbookbankRecord = data.data.data
        }).catch(function (error) { console.log(error) })
    }
  },
  created () {
    this.getBranch()
  }
})
</script>



// WEBPACK FOOTER //
// CashBook.vue?80e002e2